import script from "./GiaPhoto.vue?vue&type=script&lang=ts&setup=true"
export * from "./GiaPhoto.vue?vue&type=script&lang=ts&setup=true"

import "./GiaPhoto.vue?vue&type=style&index=0&id=1bdddd4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bdddd4c"]])

export default __exports__